import type { TFunction } from "i18next";

interface StepIndicatorProps {
  steps: number[];
  currentStep: number;
  t: TFunction<["auth"]>;
}

export const StepIndicator = ({
  steps,
  currentStep,
  t,
}: StepIndicatorProps) => {
  return (
    <div className="step-indicator">
      {steps.map((s, i) => (
        <>
          {i > 0 && (
            <div
              className={[
                "step-indicator__connector",
                s < currentStep && "step-indicator__connector--done",
              ]
                .filter(Boolean)
                .join(" ")}
            />
          )}
          <div
            key={s}
            className={[
              "step-indicator__item",
              s === currentStep && "step-indicator__item--active",
              s < currentStep && "step-indicator__item--done",
            ]
              .filter(Boolean)
              .join(" ")}
          >
            <span>{s}</span>
            {t(`resetPassword.step${s}`, { ns: "auth" })}
          </div>
        </>
      ))}
    </div>
  );
};
